// extracted by mini-css-extract-plugin
export default {"menu":"index_menu__Gwo1Q","content":"index_content__n-lns"};